import { cn } from '@/utils/cn';

export const LineSeparator = ({
  className,
  text,
}: {
  className?: string;
  text?: string;
}) => {
  if (!text) {
    return (
      <div className={cn('my-8 flex w-full items-center', className)}>
        <div className="h-px grow bg-gradient-to-r from-transparent via-gray-200 to-transparent"></div>
      </div>
    );
  }

  return (
    <div className={cn('my-8 flex w-full items-center', className)}>
      <div className="h-px grow bg-gradient-to-r from-transparent via-gray-200 to-transparent"></div>
      <span className="px-4 text-sm text-gray-500">{text}</span>
      <div className="h-px grow bg-gradient-to-r from-transparent via-gray-200 to-transparent"></div>
    </div>
  );
};
